const Btn = theme => {
  return {
    marginTop: theme.spacing.unit * 3,
    flexGrow: 1,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing.unit,
  }
}

export default Btn



// WEBPACK FOOTER //
// ./src/styles/mixins/btn.js